import { call, put, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import {
    fetchPreviousApplicationFailure,
    fetchPreviousApplicationSuccess,
    setPreviousData
} from '../../actions/ssap/ssapActionCreators';

import { getApplicationId } from '../../reducers/appReducer';
import { processJsonTools } from '../../utils/tools/processJsonTools';

export function* previousSsapDataSaga({ currentPCPApplicantGuid }) {
    const taxHouseholdType = 'object';
    const bloodRelationshipPlace = 'household';

    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const ssapApplicationId = yield select(getApplicationId);
        const previousApplication = yield call([ssapService, ssapService.getPreviousData], { ssapApplicationId });

        if(previousApplication) {
            const forSettingInAppState = processJsonTools
                .convertBloodRelationships(
                    processJsonTools.convertTaxHousehold(previousApplication, taxHouseholdType),
                    bloodRelationshipPlace,
                    undefined,
                    true
                );

            forSettingInAppState.taxHousehold.householdMember = forSettingInAppState.taxHousehold.householdMember.reduce((hhms, hhm) => {
                const { applicantGuid } = hhm;
                if(applicantGuid === currentPCPApplicantGuid) {
                    return [
                        hhm,
                        ...hhms
                    ];
                } else {
                    return [
                        ...hhms,
                        hhm
                    ];
                }
            }, []);

            yield put(setPreviousData(forSettingInAppState));
            yield put(fetchPreviousApplicationSuccess());
        } else {
            yield put(fetchPreviousApplicationFailure());
        }
    } catch(e) {
        yield put(fetchPreviousApplicationFailure());
    }
}